import "./App.css";
import "./Dark.css";
import "./responsivecss/xs.css";
import "./responsivecss/sm.css";
import "./responsivecss/md.css";
import "./responsivecss/lg.css";
import "./responsivecss/xxl.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Front from "./components/front/Front";
import Publi from "./components/publication/Publi";
import Archivum from "./components/archivum/Archivum";
import { useEffect, useState } from "react";

import { HashRouter, Route, Routes } from 'react-router-dom';
import { IntlProvider, FormattedMessage } from 'react-intl';

import en from './messages/en.json';

const i18nBags = new Map();
i18nBags.set('en', en);

const App = () => {
  const [mode, setMode] = useState(window.matchMedia("(prefers-color-scheme:dark)").matches?"dark":'light')

  const [main, setMain] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      const frontRequest = await fetch(window.PUBLICATION_DATA_URL + 'front.json',{
        method: "GET",
        headers: {
          "access-control-allow-origin" : "*",
          "Content-type": "application/json; charset=UTF-8"
        }});
      const frontObject = await frontRequest.json();

      const linkRequest = await fetch(window.PUBLICATION_DATA_URL + 'linktypes.json');
      const linkObject = await linkRequest.json();
      setMain({ ...frontObject, linktypes: linkObject });
    }
    fetchSettings();
  }, []);
  useEffect(() => {
    if (main && main !== null) {
      setLoading(false);
    }
  }, [main])

  const onSelectMode = (cuurentMode) => {
    setMode(cuurentMode)
    if (cuurentMode === 'dark') {
      document.body.classList.add('dark-mode')
      document.body.classList.add('dark')
    }
    else{
      document.body.classList.remove('dark-mode')
      document.body.classList.remove('dark')
    }
  }

  const toogleMode = () => {
    if (mode === "dark") {
      onSelectMode("light");
    }
    else {
      onSelectMode("dark");
    }
  }

  //Böngésző szín mód
  useEffect(() => {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => onSelectMode(e.matches ? 'dark' : 'light'));
    onSelectMode(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')

    return () => {
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', () => {
      });
    }
  }, []);

  const lang = document.documentElement.getAttribute('lang') === 'en' ? 'en' : 'hu';
  const messages = i18nBags.get(lang);
console.log(lang, messages);
  return (
    <IntlProvider messages={messages} locale={lang} defaultLocale='hu'>
      <HashRouter>
        {loading
          ? <div><FormattedMessage id="app.loading" defaultMessage="Betöltés..." /></div>
          : <>
            <Routes>
              <Route path='/kiadvany/:name' element={<Publi main={main} toogleMode={toogleMode} mode={mode}  />} />
              <Route path='/kiadvany/:name/:chart' element={<Publi main={main} toogleMode={toogleMode} mode={mode}  />} />
              <Route path='/archivum/:name' element={<Archivum main={main} toogleMode={toogleMode} mode={mode}  />} />
              <Route index element={<Front main={main} toogleMode={toogleMode} mode={mode} />} />
              <Route path="*" element={<Front main={main} toogleMode={toogleMode} mode={mode} />} />
            </Routes>
          </>
        }
      </HashRouter>
    </IntlProvider>
  )
}
export default App;
